import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchCalendariosLaboralesColab = async (anio = null) => {
    try {
        const params = { _t: Date.now() };
        if (anio) params.anio = anio;

        const response = await axios.get(`${API_URL}/api/calendarios-laborales-colab`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`,
                'Cache-Control': 'no-cache'
            },
            params
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchCalendarioLaboralColab = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/calendarios-laborales-colab/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const crearCalendarioLaboralColab = async (data) => {
    try {
        const response = await axios.post(`${API_URL}/api/calendarios-laborales-colab`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const actualizarCalendarioLaboralColab = async (id, data) => {
    try {
        const response = await axios.put(`${API_URL}/api/calendarios-laborales-colab/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const eliminarCalendarioLaboralColab = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/api/calendarios-laborales-colab/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const duplicarCalendarioLaboralColab = async (id, nuevoAnio) => {
    try {
        const response = await axios.post(`${API_URL}/api/calendarios-laborales-colab/${id}/duplicar`, { nuevoAnio }, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchVistaAnualCalendarioColab = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/calendarios-laborales-colab/${id}/vista-anual`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};
